import React from "react";
import { useState } from "react";
import { css } from "styled-components";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Button } from "../components/Button";
import { TextField } from "./TextField";
import { Column, Row, Spacing } from "../helpers/layout";
import { Message } from "../components/Message";
import { resetPassword } from "../actions/resetPassword";

interface FormValues {
  email: string;
}

export function ResetPasswordForm() {
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  return (
    <Formik<FormValues>
      initialValues={{ email: "" }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email()
          .required("Enter a valid email")
      })}
      onSubmit={async (values: FormValues, { setSubmitting }) => {
        setError(null);
        setSuccess(null);
        try {
          setSubmitting(true);
          await resetPassword(values);
          setSuccess("Reset link have been sent to your email successfully");
        } catch (error) {
          setError(
            error.response.data
              ? Object.values(error.response.data).join(", ")
              : "Something went wrong"
          );
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {({ isSubmitting }) => (
        <Form noValidate>
          <Column gutter={Spacing.l}>
            <TextField name="email" type="email" placeholder="Email address" />

            {success && <Message text={success} success={true} />}
            {error && <Message text={error} success={false} />}

            <Row
              justify="center"
              css={css`
                margin-top: 40px;
              `}
            >
              <Button
                isSubmitting={isSubmitting}
                type="submit"
                label={isSubmitting ? "Processing..." : "Reset Password"}
              ></Button>
            </Row>
          </Column>
        </Form>
      )}
    </Formik>
  );
}
